import classNames from 'classnames';
import type { FC } from 'react';
import { useMemo } from 'react';
import type { ILegacyProps, IProps } from './type';

export const Spin: FC<IProps | ILegacyProps> = (props) => {
  // props
  const { className } = props;
  const width = 'size' in props ? props.size : props.width;
  const height = 'size' in props ? props.size : props.height;

  return useMemo(
    () => (
      <svg
        className={classNames('animate-spin', className)}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        width={width}
        height={height}
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="#4C7CFF"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="#4C7CFF"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    ),
    [width, height, className],
  );
};
